export const lightGroupsConfig = {
    subsolo01: [
      {
        id: "grupo03", modulo: "7", idx: "3", descricao: "Circuito 03", lightType: "normal",
        instances: [
          { x: 72, y: 69, width: 2.5, height: 5, circleNumber: 3 },
          { x: 72, y: 24, width: 2.5, height: 5, circleNumber: 3 },
          { x: 92, y: 22.5, width: 2.5, height: 5, circleNumber: 3 },
          { x: 92, y: 62, width: 2.5, height: 5, circleNumber: 3 },
          { x: 80, y: 10, width: 2.5, height: 5, circleNumber: 3 },
          { x: 64, y: 10, width: 2.5, height: 5, circleNumber: 3 },
          { x: 52, y: 23, width: 2.5, height: 5, circleNumber: 3 },
          { x: 50, y: 45, width: 2.5, height: 5, circleNumber: 3 },
          { x: 50, y: 54, width: 2.5, height: 5, circleNumber: 3 },
          { x: 72, y: 51, width: 2.5, height: 5, circleNumber: 3 },
        ],
      },
    ],

    subsolo02: [
      {
        id: "grupo04", modulo: "7", idx: "4", descricao: "Circuito 04", lightType: "normal",
        instances: [
          { x: 69, y: 72, width: 2.5, height: 5, circleNumber: 4 },
          { x: 69, y: 25, width: 2.5, height: 5, circleNumber: 4 },
          { x: 84, y: 29.5, width: 2.5, height: 5, circleNumber: 4 },
          { x: 84, y: 62, width: 2.5, height: 5, circleNumber: 4 },
          { x: 80, y: 14, width: 2.5, height: 5, circleNumber: 4 },
          { x: 64, y: 14, width: 2.5, height: 5, circleNumber: 4 },
          { x: 49, y: 27, width: 2.5, height: 5, circleNumber: 4 },
          { x: 49, y: 47, width: 2.5, height: 5, circleNumber: 4 },
          { x: 49, y: 56, width: 2.5, height: 5, circleNumber: 4 },
          { x: 69, y: 49, width: 2.5, height: 5, circleNumber: 4 },
          { x: 40.7, y: 35, width: 2.5, height: 5, circleNumber: 4 },
          { x: 32, y: 56, width: 2.5, height: 5, circleNumber: 4 },
        ],
      },
    ],

    subsolo03: [
      {
        id: "grupo14", modulo: "2", idx: "2", descricao: "Circuito 14", lightType: "normal", 
        instances: [
          { x: 71, y: 69, width: 2.5, height: 5, circleNumber: 14 },
          { x: 71, y: 24, width: 2.5, height: 5, circleNumber: 14 },
          { x: 86, y: 35.5, width: 2.5, height: 5, circleNumber: 14 },
          { x: 91, y: 65, width: 2.5, height: 5, circleNumber: 14 },
          { x: 80, y: 14, width: 2.5, height: 5, circleNumber: 14 },
          { x: 64, y: 14, width: 2.5, height: 5, circleNumber: 14 },
          { x: 49, y: 27, width: 2.5, height: 5, circleNumber: 14 },
          { x: 51, y: 46, width: 2.5, height: 5, circleNumber: 14 },
          { x: 51, y: 55, width: 2.5, height: 5, circleNumber: 14 },
          { x: 71, y: 56, width: 2.5, height: 5, circleNumber: 14 },
          { x: 42.5, y: 35, width: 2.5, height: 5, circleNumber: 14 },
          { x: 80, y: 77, width: 2.5, height: 5, circleNumber: 14 },
        ],
      },
    ],
  };
  